import http from '../components/network';

const downloadExcel = async (url, params = {}, defaultFilename = 'export.xlsx') => {
  try {
    const response = await http.get(url, {
      params,
      responseType: 'blob',
    });

    const contentDisposition = response.headers?.['content-disposition'] || '';
    let filename = defaultFilename;
    const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (match && match[1]) {
      filename = match[1].replace(/['"]/g, '');
    }

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 1000);
  } catch (err) {
    console.error('Failed to download Excel:', err);
    throw err;
  }
};

export default downloadExcel;